import { NavLink, useNavigate } from "react-router-dom";
import { LiaTimesSolid } from "react-icons/lia";
import { FaRegUser } from "react-icons/fa";
import { useSelector } from "react-redux";


const DashMenu = ({ isMenuVisible, toggleMenu }) => {
  const navigate = useNavigate();
  const userInfo = useSelector(state => state.user);

  const handleSignout = () => {
    localStorage.removeItem("teslaUserInfo");
    localStorage.removeItem("teslaUserAccessToken");
    navigate("/");
  };



  return (
    <div
      className={`dash_dark_background ${isMenuVisible ? "visible" : "hidden"}`}
      onClick={toggleMenu}  // Close menu when background is clicked
    >
      <div
        className="dash_menu_container"
        onClick={(e) => e.stopPropagation()}  // Prevent closing when clicking inside the menu container
      >
        <nav className="dash_menu_cover">
          <div className="menu_profile">
            <div className="icon">
              <FaRegUser />
            </div>
            <div className="data">
              <h3 style={{ textTransform: "capitalize" }}>
                {userInfo?.firstName} {userInfo?.lastName} <br />
                <span>
                  Total Balance -{" "}
                  <b style={{ color: "rgba(0,0,0,0.7)" }}>$ {userInfo?.walletBalance} </b>
                </span>
              </h3>
              <button onClick={toggleMenu}>
                <LiaTimesSolid />
              </button>
            </div>
          </div>
          <NavLink to="/dashboard">
            <li >
              <div className="line"></div> Dashboard
            </li>
          </NavLink>
          <NavLink to="/deposit">
            <li>
              <div className="line"></div> Deposit
            </li>
          </NavLink>
          <NavLink to="/withdrawal">
            <li>
              <div className="line"></div> Withdrawal
            </li>
          </NavLink>
          <NavLink to="/profile">
            <li>
              <div className="line"></div> Profile
            </li>
          </NavLink>
          {userInfo?.role === "admin" ?
            <NavLink to="/Admin_dashboard">
              <li>
                <div className="line"></div> Admin Dashbaord
              </li>
            </NavLink> : null}
          <li onClick={handleSignout}>
            <div className="line"></div> Sign out
          </li>
        </nav>
      </div>
    </div>
  );
};

export default DashMenu;